import React, {useMemo} from "react";
import {ReactComponent as EmergeLogoIcon} from '../../../assets/themes/emerge/logo.svg';
import {ReactComponent as EmergeWhiteLogoIcon} from '../../../assets/themes/emerge/logo-white.svg';
import {ReactComponent as SquareOneLogoIcon} from '../../../assets/themes/squareone/logo.svg';
import {ReactComponent as SquareOneWhiteLogoIcon} from '../../../assets/themes/squareone/logo-white.svg';
import {ReactComponent as DefaultLogoIcon} from '../../../assets/themes/default/logo.svg';
import {useThemeSelector} from "../../../hooks/theme/useThemeSelector";

interface LogoComponentProps {
    white?: boolean
}

const iconMap = {
    emerge: EmergeLogoIcon,
    "emerge-white": EmergeWhiteLogoIcon,
    squareone: SquareOneLogoIcon,
    "squareone-white": SquareOneWhiteLogoIcon,
    default: DefaultLogoIcon,
} as const;

export const LogoComponent: React.FC<LogoComponentProps> = ({ white }) => {
    const { theme } = useThemeSelector();

    const key = white ? `${theme}-white` : theme;

    const Logo = useMemo(() => iconMap[key as keyof typeof iconMap] ?? iconMap.default, [key]);

    return <Logo />;
};